import { render, staticRenderFns } from "./ExtraStatsTable.vue?vue&type=template&id=432942d9&scoped=true&"
import script from "./ExtraStatsTable.vue?vue&type=script&lang=js&"
export * from "./ExtraStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./ExtraStatsTable.vue?vue&type=style&index=0&id=432942d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432942d9",
  null
  
)

export default component.exports